import { Box } from "@chakra-ui/react";
import * as React from "react";
import BeatLoader from "react-spinners/BeatLoader";
import { Overlay } from "../Overlay/Overlay";
export interface ILoaderCommonProps {
  isLoginLoader: boolean;
  loadingText: string;
}
export interface ILoaderCommonState {}

export default class LoaderCommon extends React.Component<
  ILoaderCommonProps,
  ILoaderCommonState
> {
  constructor(props: ILoaderCommonProps) {
    super(props);

    this.state = {};
  }

  public render(): React.ReactElement<ILoaderCommonProps> {
    return (
      <div>
        <Overlay isMenuOverlay={false}>
          <div className={"loaderContainer"}>
            <div className={"loadingText"}>{this.props.loadingText}</div>
            <BeatLoader
              speedMultiplier={1}
              size={15}
              color={"#33FFFF"}
              css={"position:fixed;top:50%"}
            />
            {this.props.isLoginLoader ? (
              <Box p={4} className="">
                <div>
                  Having trouble signing in?
                  <br />
                  Contact customer support at{" "}
                </div>
                <a href="mailto:hello@flowautobody.com.au">
                  hello@flowautobody.com.au
                </a>
              </Box>
            ) : undefined}
          </div>
        </Overlay>
      </div>
    );
  }
}
